<template>
  <div class="icon-popover">
    <div class="content">
      <p
        v-for="(item, index) in content"
        :key="index"
        :style="item.style"
      >{{item.value}}</p>
    </div>

    <el-tooltip
      class="item"
      effect="dark"
      :content="tooltipCon"
      placement="top"
      :disabled="!tooltipCon"
      v-bind="attribute"
    >
      <div
        v-if="hintCon"
        :style="hintStyle"
        class="tooltip-content"
      >
        {{hintCon}}
      </div>
    </el-tooltip>
  </div>
</template>

<script>
export default {
  props: ['scope', 'tableData'],
  data() {
    return {}
  },
  computed: {
    content() {
      let { scope, tableData } = this
      if (tableData.format) {
        let val = tableData.format(scope.row[tableData.bind], scope.row)
        return val
      }
      return scope.row[tableData.bind]
    },
    hintCon() {
      let { scope, tableData } = this
      if (typeof tableData.hintCon === 'function') {
        return tableData.hintCon(scope.row[tableData.bind], scope.row)
      }
      return tableData.hintCon
    },
    tooltipCon() {
      let { scope, tableData } = this
      if (typeof tableData.tooltipCon === 'function') {
        return tableData.tooltipCon(scope.row[tableData.bind], scope.row)
      }
      return tableData.tooltipCon
    },
    attribute() {
      let { tableData } = this
      return tableData.attribute
    },
    dataStyle() {
      let { tableData } = this
      return tableData.dataStyle
    },
    hintStyle() {
      let { tableData } = this
      return tableData.hintStyle
    },
  },
  methods: {},
  components: {},
}
</script>

<style lang="scss" scoped>
.icon-popover {
  display: flex;
  align-items: center;
  .content {
    color: #333;
  }
}
.el-tooltip.tooltip-content {
  border-radius: 4px;
  border: 1px solid #3da1ff;

  text-align: center;
  line-height: 1.5em;
  font-size: 12px;
  color: #3da1ff;

  padding: 1px 4px;
  margin-left: 10px;
  margin-bottom: 0px;

  cursor: pointer;
}
</style>
